import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Allroutes from './Allroutes/Allroutes';

function App() {
  return (
    <div className='m-auto max-w-[1640px]'>
      <Allroutes/>
    </div>
  )
}

export default App
